import networkCuratedTokens from './networkCuratedTokens.json'
import { SimpleToken } from './types'

export const networkTokens = Object.keys(networkCuratedTokens).reduce(
  (
    list: {
      name: string
      address: string
      symbol: string
      decimals: number
      chainId: number
      logoURI: string
    }[],
    chainId
  ) => {
    const networkTokens =
      networkCuratedTokens[
        chainId.toString() as '1' | '3' | '56' | '137' | '80001'
      ]
    if (networkTokens) {
      return list.concat([networkTokens.wrapped].concat(networkTokens.stables))
    }
    return list
  },
  []
)

export const getNetworkTokens = (
  chainId: number,
  type: 'all' | 'wrapped' | 'stables' = 'all'
) => {
  const networkTokens =
    networkCuratedTokens[
      chainId.toString() as '1' | '3' | '56' | '137' | '80001'
    ]
  if (networkTokens) {
    return type === 'wrapped'
      ? ([networkTokens.wrapped].concat([]) as SimpleToken[])
      : type === 'stables'
      ? (networkTokens.stables.concat([]) as SimpleToken[])
      : ([networkTokens.wrapped].concat(networkTokens.stables) as SimpleToken[])
  }
  return [] as SimpleToken[]
}
export const getNetworkWrappedToken = (chainId: number) => {
  const networkTokens =
    networkCuratedTokens[
      chainId.toString() as '1' | '3' | '56' | '137' | '80001'
    ]
  if (networkTokens) {
    return networkTokens.wrapped as SimpleToken
  }
  return undefined
}
